<template>
  <div>
    <v-card>
      <v-card-title>
        <span class="headline">Cliente</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-layout wrap>
              <v-flex xs12 sm6 lg4 d-flex>
                <v-select
                  v-bind:readonly="disabledRegistro"
                  :items="tiposDocumentos"
                  item-text="value"
                  item-value="id"
                  label="Documento de identidad"
                  :messages="errores.clienteTipoDocumento.mensajes"
                  :error="errores.clienteTipoDocumento.error"
                  v-model="registro.clienteTipoDocumento"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm5 lg3 d-flex>
                  <v-text-field label="Número documento" mask="###########" v-model="registro.clienteNumeroDocumento" :messages="errores.clienteNumeroDocumento.mensajes" :error="errores.clienteNumeroDocumento.error" v-bind:readonly="disabledRegistro"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout justify-end wrap>
              <v-flex xs8 sm3 lg3 d-flex>
              </v-flex>
              <v-flex xs4 sm2 lg2>
              </v-flex>
            </v-layout>
            <v-flex xs12 sm12>
              <v-text-field label="Cliente" v-model="registro.clienteRazonSocial" maxlenght=50 :messages="errores.clienteRazonSocial.mensajes" :error="errores.clienteRazonSocial.error" v-bind:readonly="disabledRegistro" v-on:keyup="registro.clienteRazonSocial = registro.clienteRazonSocial.toUpperCase();"></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 lg12 d-flex>
              <v-text-field label="Dirección" v-model="registro.clienteDireccion" maxlenght=50 :messages="errores.clienteDireccion.mensajes" :error="errores.clienteDireccion.error" v-bind:readonly="disabledRegistro" v-on:keyup="registro.clienteDireccion = registro.clienteDireccion.toUpperCase();"></v-text-field>
            </v-flex>
            <v-flex xs12 sm8 lg4 d-flex>
                <v-autocomplete
                   :loading="loading"
                    :items="ubigeo"
                    item-text="nombre"
                    item-value="id"
                    v-model="registro.clienteUbigeo"
                    :messages="errores.clienteUbigeo.mensajes"
                    :error="errores.clienteUbigeo.error" 
                    hide-no-data
                    hide-details
                    label="Ubigeo"
                    v-bind:readonly="disabledRegistro"
                  ></v-autocomplete>
              </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <div v-if="eliminarRegistro">
          <div>¿Seguro que desea eliminar este registro?</div>
          <v-btn color="error" dark @click.native="borrar(registro.clienteId)">Eliminar</v-btn>
          <v-btn color="primary" dark @click.native="cancelar">Cancelar</v-btn>
        </div>
        <div v-if="!eliminarRegistro">
          <v-btn color="error" dark @click.native="confirmarEliminar" v-if="disabledRegistro && !eliminarRegistro">Eliminar</v-btn>
          <v-btn color="success" dark @click.native="guardar(registro.clienteId)" v-if="!disabledRegistro">Guardar</v-btn>
          <v-btn color="primary" dark @click.native="editar" v-if="disabledRegistro">Editar</v-btn>
          <v-btn color="primary" dark @click.native="cerrar">Cerrar</v-btn>
        </div>
      </v-card-actions>
      <br />
    </v-card>
    <v-card v-if="disabledRegistro">
      <br />
      <comprobantes-lista v-bind:ubigeo="ubigeo" v-bind:idCliente="registro.clienteId"></comprobantes-lista>
    </v-card>
  </div>
</template>

<script>
import mixin from '../mixins.js'
export default {
  mixins: [mixin],
  name: 'cliente',
  props: {
    idRegistro: 0,
    ubigeo: {}
  },
  data: () => ({
    disabledRegistro: false,
    eliminarRegistro: false,
    loading: false,
    datos: [],
    tiposDocumentos: [
      { id: '-', value: '-- Sin documento --' },
      { id: '1', value: 'DNI' },
      { id: '6', value: 'RUC' },
      { id: '4', value: 'Carnet de extranjería' },
      { id: '7', value: 'Pasaporte' }
    ],
    registro: {},
    errores: {
      'clienteRazonSocial': {mensajes: [], error: false},
      'clienteDireccion': {mensajes: [], error: false},
      'clienteTipoDocumento': {mensajes: [], error: false},
      'clienteNumeroDocumento': {mensajes: [], error: false},
      'clienteUbigeo': {mensajes: [], error: false}
    }
  }),
  created () {
    this.initialize()
  },
  watch: {
    idRegistro () {
      if (this.idRegistro !== '') {
        this.ver({id: this.idRegistro})
      }
    }
  },
  methods: {
    initialize () {
      this.datos = {}
    },
    ver (item) {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = []
      const myRequest = new Request(`${process.env.NODE_API}cliente/ver/id/` + item.id, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            this.registro = datos.d.cliente
            this.errores = datos.d.errores
            this.eliminarRegistro = false
            if (item.id === 0) {
              this.registro.clienteId = 0
              this.registro.clienteTipoDocumento = '-'
              this.disabledRegistro = false
            } else {
              this.disabledRegistro = true
            }
          }
        })
    },
    guardar (id) {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = this.registro
      const myRequest = new Request(`${process.env.NODE_API}cliente/guardar/id/` + id, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            if (datos.e === 1) {
              this.ver(datos.d)
              this.$emit('listar')
            } else {
              this.errores = datos.d.errores
            }
          }
        })
    },
    editar () {
      this.disabledRegistro = false
    },
    cerrar () {
      this.$emit('cerrar')
    },
    confirmarEliminar () {
      this.eliminarRegistro = true
    },
    cancelar () {
      this.eliminarRegistro = false
    },
    borrar (id) {
      var solicitudApi = this.crearSolicitud()
      const myRequest = new Request(`${process.env.NODE_API}cliente/borrar/id/` + id, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            if (datos.e === 1) {
              this.$emit('listar')
              this.cerrar()
            } else {
              this.errores = datos.d.errores
            }
          }
        })
    }
  }
}
</script>

<style>
.v-btn--floating .v-icon {
    height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Cliente.vue